<template>

    <div class="home">
        <HeadBar />
        <div class="banner">
            Use Code Take20%off to receive 20% off your subscription
        </div>
        <div style="background: #f1f2f6;">
            <div class="hero-section">
                <div class="hero-inner">
                    <div class="hero-left">
                        <h1 class="hero-title">
                            Tradesmen &amp;<br>
                            Building Contractors.<br>
                            Generate Contracts for<br>
                            Your Clients <span class="hl-green">Quickly</span><br>
                            and <span class="hl-purple">Efficiently</span>
                        </h1>
                        <div class="hero-underline"></div>
                        <p class="hero-desc">
                            Create professional contracts in minutes,
                            customize every detail, and get back to what
                            you do best—building.
                        </p>
                        <button class="hero-cta" onclick="window.location.href='/Login?t=signup'">
                            Create Your First Contract <span class="cta-arrow">→</span>
                        </button>
                    </div>
                    <div class="hero-right">
                        <img src="../assets/img/ContractlyHero.png" class="hero-img" alt="Contractly" />
                    </div>
                </div>

                <div class="features-bar">
                    <div class="feature-item">
                        <img src="../assets/img/1.png" class="feature-icon" />
                        <div>
                            <div class="feature-title">Save Time</div>
                            <div class="feature-desc">Create contracts in minutes</div>
                        </div>
                    </div>
                    <div class="feature-item">
                        <img src="../assets/img/2.png" class="feature-icon" />
                        <div>
                            <div class="feature-title">Custom Templates</div>
                            <div class="feature-desc">Tailor every detail to your projects</div>
                        </div>
                    </div>
                    <div class="feature-item">
                        <img src="../assets/img/3.png" class="feature-icon" />
                        <div>
                            <div class="feature-title">Client Ready</div>
                            <div class="feature-desc">Professional contracts your clients trust</div>
                        </div>
                    </div>
                    <div class="feature-item">
                        <img src="../assets/img/4.png" class="feature-icon" />
                        <div>
                            <div class="feature-title">Work Anywhere</div>
                            <div class="feature-desc">Access and manage from any device</div>
                        </div>
                    </div>
                    <div class="feature-item">
                        <img src="../assets/img/5.png" class="feature-icon" />
                        <div>
                            <div class="feature-title">Built for Contractors</div>
                            <div class="feature-desc">Designed for the way you work</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" style="max-width: 912px;">  

                <div class="row" style="margin-top: 30px;">
                    <div class="gradient-text">
                        What Can <span class="gradient2">Contr</span><span class="gradient3">actly</span> Do For <span class="gradient">You</span>?
                    </div>

                </div>

                <div class="row">

                    <div class="block-container">
                        <div class="gradient-btn btn-1">Send clear, professional contracts directly to your clients and sub-contractors quickly and easily.</div>
                        <div class="gradient-btn btn-2">Save you time and free you from writing contract terms on your evenings and weekends.</div>
                        <div class="gradient-btn btn-3">No more consultations with lawyers and associated costly fees - you're in control!</div>
                        <div class="gradient-btn btn-4">Build trust and lasting business relationships with your clients and sub-contractors.</div>
                        <div class="gradient-btn btn-5">Formalize your relationship with clients for both big and small jobs using a comprehensive contract that clearly outlines all relevant details.</div>
                        <div class="gradient-btn btn-6">Say goodbye to paper and email trails, and eliminate misunderstandings with streamlined contract management.</div>
                    </div>

                </div>
            </div>
        </div>

        <div style="background: #f1f2f6; padding: 1rem 0rem;">
            <div class="container">
                <div class="row">
                    <div class="gradient-text" style="color: black; margin: 40px 0px 16px 0px;">
                        How Does <span style="color: #5460c1;">Contractly</span> Work To <span style="color: #065530;">Protect You</span>
                    </div>                  
                </div>
                <div class="row clear-concise" style="margin-top: 16px; align-items: center;" >
                    <div class="col-12">
                        <div class="subtitle mt-8 mb-4" style="color: white;">Clear Concise Client Contracts</div>
                    </div>
                    
                    <div class="offset-md-1 col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"> <img src="../assets/img/ICON1.png" style="width:25px" /></div>
                            <div>
                                Clearly outline your responsibilities for the project, from start to finish.
                            </div>
                            
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-5 col-12">    
                        <div class="button-box">
                            <div class="icon"><div class="icon"> <img src="../assets/img/ICON7.png" style="width:25px" /></div></div>
                            <div>
                                Built-in limitation of liability that greatly reduces your risk of financial loss.                               
                            </div>
                        </div>
                    </div>
                    <div class="offset-md-1 col-sm-6 col-md-5 col-12">          
                        
                        <div class="button-box">
                            <div class="icon"><div class="icon"> <img src="../assets/img/ICON3.png" style="width:25px" /></div></div>
                            <div>
                                Clearly define payment terms for you and your 
                                client, including first deposit date and final 
                                payment date.
                            </div>
                            
                        </div>
                    </div>
                    
                    <div class="col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"><div class="icon"> <img src="../assets/img/ICON2.png" style="width:25px" /></div></div>
                            <div>
                                Define the commencement and completion dates of your projects, with increased flexibility for the contractor.
                            </div>
                            
                        </div>
 
                  
                    </div>
                </div>

                <div class="row sub-bg" style=" align-items: center;">
                    <div class="col-12 offset-md-2 col-md-8">
                        <div class="subtitle mt-8 mb-4" style="color: white;">
                            Do You Engage With Sub-Contractors on your Projects? <br />
                            Hold your sub-contractors accountable with our agreements. 
                        </div>
                    </div>

                    <div class="offset-md-1 col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"> <img src="../assets/img/ICON2.png" style="width:25px" /></div>
                            <div>
                                Hold your sub-contractor to a 
                                defined scope of services.
                            </div>
                            
                        </div>
                    </div>
                    <div class=" col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"> <img src="../assets/img/ICON1.png" style="width:25px" /></div>
                            <div>
                                Define all of your sub-contractors payment terms.
                            </div>
                            
                        </div>
                    </div>
                    <div class="offset-md-1 col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"> <img src="../assets/img/ICON8.png" style="width:25px" /></div>
                            <div>
                                Clearly define commencement 
                                date to completion date.
                            </div>
                            
                        </div>
                    </div>
                    <div class=" col-sm-6 col-md-5 col-12">
                        <div class="button-box">
                            <div class="icon"> <img src="../assets/img/ICON6.png" style="width:25px" /></div>
                            <div>
                                Termination clauses protect you 
                                and clearly outline all potential 
                                reasons for termination of your 
                                sub-contractors.
                            </div>
                            
                        </div>
                    </div>
                   
               </div>
            </div>
            
        </div>

        <div class="banner">
            Use Code Take20%off to receive 20% off your subscription
        </div>
        <div style="background-color: #f1f2f6; padding: 0 0 24px 0;">
            <div class="container" >
                <div class="row">
                    <div class="col-12 gradient-text" style="margin: 24px auto; ">
                        <span class="gradient3" >Formalize</span> Your Agreements & Your Business
                    </div>
                    
 
                </div>
                <div class="row">

                    <div class="col-12 font-ajust text-center" style="margin: auto; position: relative;">

                        
                        <div style="flex: 1;">
                            Take control of your projects with contractly's contract <br /> 
                            management. Sign up now and start formalizing agreements with <br /> 
                            your clients and subcontractors.

                             
                        </div>
                       
                        
                    </div>
                    
                </div>
                <div class="row" style="margin-top: 24px; ">
                    <div style="display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; " v-if="subscriptionPlans!=null">
                        <div v-for="obj in subscriptionPlans" :key="obj.Id">
                            <div :class="`price-bg background${obj.Type}`">
                                <template v-if="obj.Type==1">
                                    <div class="price-text">
                                        {{ obj.TrialDays }}-Day {{obj.Name}}
                                    </div>
                                    <div class="price">&nbsp;</div>
                                </template>
                                <template v-else>
                                    <div class="price-text">
                                        {{obj.Name}}
                                    </div>
                                    <div class="price">${{obj.Price}} CAD <span style="color:#473d82">Billed {{obj.Type==2?'Monthly':obj.Type==3?'Annually':'-'}}</span></div>
                                </template>
                                

                                <div class="get-started" onclick="window.location.href='/Login?t=signup'">Get Started</div>
                                <div class="price-info" style="margin-top: 24px;" v-html="obj.Line1"></div>
                                <div class="price-info" v-html="obj.Line2"></div>
                                <div class="price-info" v-html="obj.Line3"></div>
                            </div>
                        </div>

                        

                    </div>
                    
                </div>
            </div>
        </div>
 

        <Foot />
        <SignIn ref="signIn"></SignIn>
        <SignUp ref="signUp" :partyId="partyId" @showTerms="onShowTerms"></SignUp>
        <CommonInfo ref="terms"></CommonInfo>
    </div>
</template>

<script>
    
    import HeadBar from '../components/HeadBar';
    import Foot from '../components/Foot';
    import SignIn from '../components/SignIn';
    import SignUp from '../components/SignUp';
    import CommonInfo from '../components/CommonInfo';
    import { isNullOrEmpty } from '../composables/utils';
    import http from '../composables/http';



    export default {
        name: 'home-test',
        components: {
            HeadBar, Foot, SignIn, SignUp, CommonInfo
        },
        data() {
            return {
                settings: null,
                subscriptionPlans:[],
                partyId: null
            }
        },
        mounted() {
            const key = this.$route.query.key;
            if (key!=null) {
                http.request("get", "/api/common/readkey", { key }).then(res => {
                    console.log("key", res);
                    if (res?.Type == 200) {
                        if (res.Content == "Your account has been activated successfully" && !isNullOrEmpty(res.Data?.PhoneNumber)) {
                            this.$router.push(`/login?s=preset&account=${res.Data.PhoneNumber}`)
                        }
                    }

                });
            } 

            http.request("get", `/api/site/subscriptionplans`).then(res => {
                    if (res?.Type == 200) {
                        this.subscriptionPlans = res.Data;
                    }

                });

            if (this.$route.query.ref != null
                && this.$route.query.key != null
                && this.$route.query.email != null) {
                this.$refs.signUp.show();
            }
            else {
                if (this.$route.query.usr != null) {
                    this.$refs.signIn.show();
                }
            }
        },
        methods: {
            signIn() {               
                //this.$router.push('/SignIn');
                this.$refs.signIn.show();
            },
            signUp() {
                //this.$router.push('/SignUp');
                this.$refs.signUp.show();
            },
            onShowTerms() {
                this.$core.GetUserTerms().then((x) => {
                    if (x.Message != '') {
                        alert(x.Message);
                    } else {
                        this.$refs.terms.show("Terms of Services",x.Object);
                    }
                });               
            }
        }
    };
</script>
<style>
    @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans&family=Roboto&display=swap');
</style>
 
<style scoped>

    .banner {
        background-color: #ff6666;
        font-size: clamp(16px, 2vw, 24px);
        color: white;
        width: 100%;
        min-width: 100%;
        text-align: center;
        padding: 8px 0px;
        font-weight: bold;
    }

    .gif-container {
         
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center; /* Center horizontally */
        align-items: flex-end; /* Align to the bottom */
    }
    .price-bg {
        margin: 8px auto;
        max-width: 300px;
        min-height: 400px;
        border-radius: 8px;
        padding: 8px;
        height: calc(100% - 16px);
    }
    .background1{
        background-image: url('../assets/img/Price1background.png');
        background-size: cover;
    }
    .background2{
        background-image: url('../assets/img/Price2background.png');
        background-size: cover;
    }
    .background3{
        background-image: url('../assets/img/Price3background.png');
        background-size: cover;
    }
    .price{
        font-size: clamp(11px, 1.3vw, 15px);
        color: black;
        font-weight: bold;
        padding: 0 16px;
        margin-bottom: 16px;
        height: 20px;
    }
    .price-text{
        font-size: clamp(18px, 1.4vw, 28px);
        color: black;
        font-weight: bold;
        padding: 16px;
    }
    .get-started{
        border: 2px solid black;
        font-size: clamp(14px, 1.4vw, 18px);
        border-radius: 8px;
        cursor: pointer;
        width: 90%;
        font-weight: bold;
        margin: 0 auto;
        padding: 4px 0px;
        text-align: center;
    }
        .get-started:hover {
            border-color: #473d82; /* �߿���ɫ��Ϊ�������ɫ */
            background-color: rgba(71, 61, 130, 0.05); /* ��΢����ɫ */
            transition: border-color 0.3s, background-color 0.3s;
        }
    .price-info{
        font-size: 14px;
        padding: 8px 15px;
    }
    .font-ajust { font-size: clamp(12px, 2vw, 16px); color: black; }
    .subtitle{
        font-size: clamp(18px, 2vw, 24px);
        color: black;
        font-weight: bold;
        text-align: center;
    }
    .gradient-text {
        font-size: clamp(20px, 2vw, 36px);
        font-weight: bold;
        color: #222;
        text-align: center;
    }

    .gradient-text .gradient {
        background: linear-gradient(90deg, #406d9d, #6058d8);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient2 {
        background: linear-gradient(90deg, #6f67e2, #6f67e2);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient3 {
        background: linear-gradient(90deg, #5e59d5, #406d9d);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }


    .gradient-text .gradient4 {
        background: linear-gradient(90deg, #6f67e2, #6f67e2);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .gradient-text .gradient5 {
        background: linear-gradient(90deg,#5a90c7, #52b9b5);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .icon{margin: 0px;}
    .button-box{
        /*background:linear-gradient(90deg, #7fcfaa, #51ab8a);*/
        font-size: clamp(14px, 1.5vw, 18px);
        font-weight: bold;
        /* Dynamic font size */
        width: 90%;
        margin: 16px auto;
        color: white;
        padding: 20px;
        display: flex;
        gap: 12px;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        align-content: center;
        justify-content: center;
        min-height: 100px;
        overflow: hidden;
    }
    .block-container {
        display: flex;
        flex-wrap: wrap; /* Allow wrapping for desktop */
        gap: 50px; /* Space between cards */
        justify-content: center; /* Center items */
        flex-wrap: wrap;       
        max-width: 900px;
        margin: 24px auto;
       
    }

    /* Button Style */
    .gradient-btn {
            flex: 1 1 calc(33.33% - 40px); /* 3 items per row with gap adjustment */
            max-width: 230px; /* Ensure max 3 items per row */
            min-width: 230px; /* Minimum width for readability */
            background-color: #e6f0fa;
            border-radius: 10px;
            padding: 130px 20px 20px 20px;
            text-align: left;
            position: relative;
            background-size: cover;
    }


    /* Specific Background Images */
    .btn-1 {
        background-image: url('../assets/img/BLOCK1.png');
    }

    /* Replace with actual image URL */
    .btn-2 {
        background-image: url('../assets/img/BLOCK2.png');
    }

    .btn-3 {
        background-image: url('../assets/img/BLOCK3.png');
    }

    .btn-4 {
        background-image: url('../assets/img/BLOCK4.png');
    }
    .btn-5 {
        background-image: url('../assets/img/BLOCK5.png');
    }
    .btn-6 {
        background-image: url('../assets/img/BLOCK6.png');
    }

    /* Hover Effect */
    .gradient-btn:hover {
        opacity: 0.9;
    }

    .clear-concise {
        background-image: url('../assets/img/CLEARBG.png');
        background-size: cover;
        background-position: center;
        max-width: 912px;
        justify-self: center;
        align-items: center;
        margin: auto;
    }
    .sub-bg {
        background-image: url('../assets/img/SUBCONTRACTORAGREEMENTBG.png');
        background-size: cover;
        background-position: center;
        max-width: 912px;
        justify-self: center;
        align-items: center;
        margin: auto;
    }

    .title-text{
        font-size: 28px; color: #132338; max-width: 800px; text-align: center; font-weight: 900;
    }

    .title-class{
        justify-items: center;
        display: grid;
    }

    /* Hero */
    .hero-section {
        background: #f7f7f8;
        padding: 24px 16px 32px;
    }

    .hero-inner {
        max-width: 1400px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        gap: 24px;
    }

    .hero-left {
        flex: 0 0 42%;
        padding-left: 4%;
    }

    .hero-right {
        flex: 1;
        text-align: center;
    }

    .hero-img {
        width: 100%;
        max-width: 950px;
    }

    .hero-title {
        font-size: clamp(28px, 3.2vw, 48px);
        font-weight: 900;
        line-height: 1.15;
        color: #132338;
        margin: 0;
        text-align: left;
    }

    .hl-green {
        color: #1a7a45;
    }

    .hl-purple {
        color: #6f67e2;
    }

    .hero-underline {
        width: 210px;
        height: 5px;
        border-radius: 4px;
        background: #6f67e2;
        margin: 18px 0 22px;
        transform: rotate(-2deg);
    }

    .hero-desc {
        font-size: clamp(14px, 1.2vw, 18px);
        color: #4a5568;
        max-width: 440px;
        line-height: 1.6;
        margin-bottom: 28px;
        text-align: left;
    }

    .hero-cta {
        background: #1a7a45;
        color: #fff;
        font-weight: bold;
        font-size: clamp(14px, 1.1vw, 17px);
        border: none;
        border-radius: 8px;
        padding: 14px 26px;
        cursor: pointer;
        transition: background .2s;
    }

        .hero-cta:hover {
            background: #146036;
        }

    .cta-arrow {
        margin-left: 8px;
    }

    /* Features bar */
    .features-bar {
        max-width: 1500px;
        margin: 32px auto 0;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 2px 10px rgba(0,0,0,.05);
        display: flex;
        padding: 22px 10px;
    }

    .feature-item {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0 22px;
        border-right: 1px solid #eceef1;
    }

        .feature-item:last-child {
            border-right: none;
        }

    .feature-icon {
        width: 58px;
        height: 58px;
        flex: 0 0 58px;
    }

    .feature-title {
        font-weight: 800;
        color: #132338;
        font-size: clamp(14px, 1vw, 17px);
        margin-bottom: 4px;
    }

    .feature-desc {
        color: #6b7280;
        font-size: clamp(12px, .85vw, 14px);
        line-height: 1.35;
    }

    /* Responsive */
    @media (max-width: 992px) {
        .hero-inner {
            flex-direction: column;
        }

        .hero-left {
            flex: none;
            width: 100%;
            padding-left: 0;
            text-align: center;
        }

        .hero-title, .hero-desc {
            text-align: center;
        }

        .hero-underline {
            margin: 18px auto 22px;
        }

        .hero-desc {
            margin: 0 auto 24px;
        }

        .features-bar {
            flex-wrap: wrap;
            gap: 16px 0;
        }

        .feature-item {
            flex: 1 1 50%;
            border-right: none;
        }
    }

    @media (max-width: 576px) {
        .feature-item {
            flex: 1 1 100%;
        }
    }
    

    /* Responsive */
    @media (max-width: 768px) {
         
        .title-text{
            font-size: 20px;
            max-width : unset;
            text-align: center;
        }

        .block-container {
                flex-wrap: nowrap; /* Prevent wrapping on mobile */
                overflow-x: auto; /* Enable horizontal scrolling */
                justify-content: flex-start; /* Align items to the left */
                padding-bottom: 10px; /* Space for scrollbar */
                gap: 20px;
            }

            .gradient-btn {
                flex: 0 0 80%; /* Each card takes 80% of the viewport width */   
                width: 220px; /* Minimum width for readability */
            }
        
            
    }
</style>

